// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getConfigInventory = createAsyncThunk(
  'configInventory/getConfigInventory',
  async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_API}Schedule/configInventory/configInventoryEdit`
    )
    return response.data.Response.item
  }
)

export const addConfigInventory = createAsyncThunk('configInventory/addConfigInventory', async (CreateConfigInventory) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/configInventory/configInventoryCreate`, {
    Request: {
      CreateConfigInventory
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return CreateConfigInventory
})

export const updateConfigInventory = createAsyncThunk('configInventory/addConfigInventory', async (UpdateConfigInventory) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/configInventory/configInventoryUpdate`, {
    Request: {
      UpdateConfigInventory
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  return UpdateConfigInventory
})

export const appCategoriesSlice = createSlice({
  name: 'configInventories',
  initialState: {
    data: [],
    selectedConfigInventory: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getConfigInventory.pending, (state) => {
        state.loading = true
        console.log("pending", true)
      })
      .addCase(getConfigInventory.fulfilled, (state, action) => {
        console.log("fulfilled", false)
        state.loading = false
        state.selectedConfigInventory = action.payload
      })
      .addCase(getConfigInventory.rejected, (state, action) => {
        console.log("rejected", action.payload)
        state.loading = false
        state.error = action.payload || 'Error API'
      })
  }
})

export default appCategoriesSlice.reducer
